import React, { useState } from "react";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import "./style.css";

const Recovery = ({ open, handleCloseRecovery, recoveryCode }) => {
  const [isChecked, setIsChecked] = useState(false);
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(recoveryCode || "");
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <>
 
      <Modal className="modal-2fa" isOpen={open} toggle={handleCloseRecovery} centered>
        <ModalHeader toggle={handleCloseRecovery}>
          Recovery Code 
        </ModalHeader>

        <ModalBody>
          <div className="text-center mb-4">
            <p className="text-danger font-weight-bold text-uppercase mb-2">
              Almost Done!
            </p>
            <p className="text-muted small">
              Make sure you save this code somewhere safe. It is the only way to
              get access to your account if you lock yourself out.
            </p>
          </div>

          {/* Recovery Code Section */}
          <div className="recovery-code-box">
            <input
              type="text"
              disabled
              value={recoveryCode || ""}
              className="recovery-code-input"
              readOnly
            />
            <button
              className="copy-btn"
              onClick={handleCopy}
              title="Copy to clipboard"
            >
              {copied ? "✓ Copied" : "Copy"}
            </button>
          </div>
          <div className="checkbox-agreement">
            <input
              type="checkbox"
              id="recovery-agreement"
              checked={isChecked}
              onChange={(e) => setIsChecked(e.target.checked)}
            />
            <label htmlFor="recovery-agreement">
              I understand that losing this code means{" "}
              <span className="text-danger-emphasis">
                losing access to my account forever
              </span>{" "}
              and support will not be able to help me.
            </label>
          </div>

          {/* Action Buttons */}
          <div>
            <Button
              color="primary"
              className="btn-copy w-100 mb-3"
              onClick={handleCopy}
            >
              {copied ? "✓ Copied to Clipboard" : "Copy Recovery Code"}
            </Button>

            <Button
              className="btn-finish w-100"
              disabled={!isChecked}
              onClick={handleCloseRecovery}
            >
              Finish Setup
            </Button>
          </div>
        </ModalBody>

        <ModalFooter>
          <div className="alert-important w-100">
            <div className="alert-important-header">
              <div className="alert-dot"></div>
              <p className="alert-important-title">Important</p>
            </div>
            <p className="alert-important-text">
              Store this recovery code in a secure location such as a password
              manager or write it down and keep it in a safe place. Screenshot
              or copy it now - you won't see it again!
            </p>
          </div>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default Recovery;